import React, { useState, useEffect } from 'react';
import TIdDoc from './TIdDoc';
import AlertMessage from '../../AlertMessage';

const TIdCard = () => {
  const [formData, setFormData] = useState({}); // Keep formData as an object
  const [udiseNumber, setUdiseNumber] = useState('');
  const [language, setLanguage] = useState(localStorage.getItem("language") || "English");
  const [submitted, setSubmitted] = useState(false);
  const [selectedTeachers, setSelectedTeachers] = useState([]);
  const [showDuplicatePopup, setShowDuplicatePopup] = useState(false);
  const [teachers, setTeachers] = useState([]);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [mobileNumber, setMobileNumber] = useState('');


  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);

  useEffect(() => {
    const storedLanguage = localStorage.getItem("language") || "English";
    setLanguage(storedLanguage);
  }, []);

  useEffect(() => {
    const schoolUdiseNumber = localStorage.getItem("udiseNumber");
    if (schoolUdiseNumber) {
      setUdiseNumber(schoolUdiseNumber);
    }
  }, []);

  useEffect(() => {
    const fetchTeachers = async () => {
      try {
        const udiseNumber = localStorage.getItem("udiseNumber");
        if (!udiseNumber) {
          console.error("UDISE number is not available in localStorage.");
          return;
        }

        const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData.json`);
        if (!response.ok) {
          throw new Error('Failed to fetch teacher data');
        }

        const data = await response.json();
        if (data) {
          const teacherList = Object.values(data)
            .filter(teacher => teacher !== null)
            .map(teacher => ({
              Name: teacher.Name || '',
              Mobno: teacher.Mobno || '',
              DOB: teacher.Personaldetails?.DOB || '', // Safely access nested properties
              DOJ: teacher.Currentteacher?.DOJ || '', // Safely access nested properties
              Qualification: teacher.TeacherDetails?.education || '', // Safely access nested properties
              Designation: teacher.TeacherDetails?.position || '', // Safely access nested properties
              Image: teacher.Image || '', // Safely access nested properties
              subject: teacher.TeacherDetails?.subject || '', // Safely access nested properties
            }));
          setTeachers(teacherList);
          setShowDuplicatePopup(true);
        } else {
          console.error("No teacher data found.");
        }
      } catch (error) {
        console.error('Error fetching teacher data:', error);
      }
    };

    fetchTeachers();
  }, []);

  const handleReset = () => {
    setFormData({});
    setSubmitted(false);
    setSelectedTeachers([]);
    window.location.reload();
  };

  const DuplicateTeacherPopup = ({ teachers, onSelectTeachers, onConfirm }) => {
    const [selectedTeachers, setSelectedTeachers] = useState([]);
    const [teacherSubjects, setTeacherSubjects] = useState({}); // State to hold subjects per teacher

    useEffect(() => {
      // Pre-fill the subject fields for selected teachers
      const initialSubjects = teachers.reduce((acc, teacher) => {
        acc[teacher.Mobno] = teacher.subject || ''; // Use existing subject if available
        return acc;
      }, {});
      setTeacherSubjects(initialSubjects);
    }, [teachers]);

    const handleCheckboxChange = (teacher) => {
      const updatedSelectedTeachers = selectedTeachers.includes(teacher)
        ? selectedTeachers.filter((t) => t !== teacher)
        : [...selectedTeachers, teacher];
      setSelectedTeachers(updatedSelectedTeachers);
    };

    const handleSelectAllChange = (event) => {
      setSelectedTeachers(event.target.checked ? teachers : []);
      const initialSubjects = event.target.checked
        ? teachers.reduce((acc, teacher) => ({ ...acc, [teacher.Mobno]: teacher.subject || '' }), {})
        : {};
      setTeacherSubjects(initialSubjects);
    };

    const handleSubjectChange = (event, teacher) => {
      setTeacherSubjects({ ...teacherSubjects, [teacher.Mobno]: event.target.value });
    };

    const handleConfirmSelection = async () => {
      if (selectedTeachers.length > 0) {
        for (const teacher of selectedTeachers) {
          const databaseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData`;
          const firebaseUrl = `${databaseUrl}/${udiseNumber}/AttData/${teacher.Mobno}/TeacherDetails.json`;

          // Data to be saved
          const updatedData = {
            ...teacher,
            subject: teacherSubjects[teacher.Mobno] || null, // Save subject or null if empty
          };

          try {
            // Save to Firebase
            const response = await fetch(firebaseUrl, {
              method: 'PATCH', // Use PATCH to update specific fields
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(updatedData),
            });

            if (response.ok) {
              console.log(`Subject for ${teacher.Name} saved successfully!`);
            } else {
              console.error(`Failed to save subject for ${teacher.Name}:`, await response.text());
            }
          } catch (error) {
            console.error(`Error saving subject for ${teacher.Name}:`, error);
          }
        }

        // Update the selected teachers with the new subject data
        const updatedTeachersWithSubjects = selectedTeachers.map((teacher) => ({
          ...teacher,
          subject: teacherSubjects[teacher.Mobno] || '',
        }));
        onConfirm(updatedTeachersWithSubjects);
      }
      setShowDuplicatePopup(false);
    };

    const isAllSelected = selectedTeachers.length === teachers.length;

    return (
      <div className="popup">
        <h5 style={{ color: '#0047AB', fontWeight: '600', marginBottom: '15px', textAlign: 'center' }}>
          {language === "English" ? "Select Staff & Assign Subject if Teacher (Optional)" : "कर्मचारी निवडा आणि शिक्षक असल्यास विषय नियुक्त करा (पर्यायी)"}
        </h5>
        <hr style={{ borderTop: '1px solid #ccc', marginBottom: '15px' }} />
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', paddingLeft: '10px', width: '100%' }}>
          <input
            type="checkbox"
            checked={isAllSelected}
            onChange={handleSelectAllChange}
            style={{ height: '16px', width: '16px', marginRight: '10px' }}
          />
          <label style={{ fontSize: '16px', maxWidth: '500px', marginLeft:'30px' }}>
            {language === "English" ? "Select All" : "सर्व निवडा"}
          </label>
        </div>
        <hr/>
        <ul className="teacher-list" style={{ listStyleType: 'none', padding: 0, maxHeight: '300px', overflowY: 'auto' }}>
          {teachers.map((teacher, index) => (
            <li key={index} style={{ display: 'flex', alignItems: 'center', padding: '8px 10px', marginBottom: '5px', width: '100%', borderBottom: '1px solid #ccc' }}>
              <input
                type="checkbox"
                checked={selectedTeachers.includes(teacher)}
                onChange={() => handleCheckboxChange(teacher)}
                style={{ height: '16px', width: '16px', marginRight: '10px' }}
              />
              <label style={{ fontSize: '16px', width: '250px', marginRight: '20px' }}>{teacher.Name}</label>
              <input
                type="text"
                placeholder={language === "English" ? "Enter Subject" : "विषय प्रविष्ट करा"}
                value={teacherSubjects[teacher.Mobno] || ''}
                onChange={(event) => handleSubjectChange(event, teacher)}
                style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '14px', flexGrow: 1 }}
              />
            </li>
          ))}
        </ul>
        <button
          className="confirm-button"
          onClick={handleConfirmSelection}
          style={{
            backgroundColor: '#8A1538',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            padding: '10px 20px',
            cursor: 'pointer',
            fontSize: '16px',
            width: '100%',
            marginTop: '20px',
          }}
        >
          {language === "English" ? "Confirm" : "पुष्टी करा"}
        </button>
        <style jsx>{`
          .popup {
            background-color: white;
            border-radius: 8px;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
            padding: 20px 20px;
            width: 100%;
            max-width: 800px;
          }
        `}</style>
      </div>
    );
  };

  return (
    <div className="home">
      <AlertMessage message={alertMessage} show={showAlert} />
      {showDuplicatePopup && (
        <div className="popup-container">
          <div className="popup">
            <DuplicateTeacherPopup 
              teachers={teachers}
              onSelectTeachers={setSelectedTeachers} // Update selectedTeachers state
              onConfirm={(selectedTeachers) => {
                setSelectedTeachers(selectedTeachers);
                // Construct formData based on selected teachers
                const formDataForIdCard = selectedTeachers.reduce((acc, teacher, index) => {
                  acc[`teacherName_${index}`] = teacher.Name;
                  acc[`teacherMobile_${index}`] = teacher.Mobno;
                  acc[`teacherDOB_${index}`] = teacher.DOB;
                  acc[`teacherDOJ_${index}`] = teacher.DOJ;
                  acc[`teacherQualification_${index}`] = teacher.Qualification;
                  acc[`teacherDesignation_${index}`] = teacher.Designation;
                  acc[`teacherSubject_${index}`] = teacher.subject || ''; // Add subject if available
                  return acc;
                }, {});
                setFormData(formDataForIdCard);
                setSubmitted(true);
              }}
            />
          </div>
        </div>
      )}

      <div className="id-container" style={{ float: 'center', left: '0', marginLeft: '150px' }}>
        <h3 className='text-center mb-5' style={{ color: '#1B4332', fontWeight: '600', marginTop: '20px' }}>{language === "English" ? "Staff Identity Card" : "कर्मचारी ओळख पत्र"}</h3>
        <div className="form-output">
          <form>
            <br />
            <div className="form-buttons" style={{ float: 'right', right: '0' }}>
              <button className="reset-btn" type="button" onClick={handleReset} style={{ marginLeft: '30px', marginTop: '-9px', padding: '8px 10px' }}>{language === "English" ? "Reset" : "रीसेट करा"}</button>
            </div>
            <div>
            </div>
          </form>
        </div>
      </div>
      <div style={{ width: '70%' }}>
        <TIdDoc
          submitted={submitted}
          formData={formData}
          selectedTeachers={selectedTeachers.map((teacher) => ({
            ...teacher,
            subject: teacher.subject || '', 
          }))}
        />
      </div>
    </div>
  );
};

export default TIdCard;